module.exports = __webpack_public_path__ + "media/images/athletes/2125-eecd655241eab84658011a7f6955d4c2.png";